import { type FC, useEffect } from 'react';
import styles from '../styles/purpose-selection.module.scss';
import type { RepairBookingSession, RepairService } from '../models/repair-bookings';
import AttentionNotice from '../components/attention-notice';
import PageTitle from '../components/page-title';
import PageActions from '../components/page-actions';
import useRepairOptions from '../hooks/use-repair-options';

const PurposeSelection: FC<{
    session: RepairBookingSession;
    productId: number;
    selectedServices: RepairService[];
    toggleService: (service: RepairService) => void;
    actionTitle?: string;
    onComplete: () => void;
    onCancel: () => void;
}> = ({
    session,
    productId,
    selectedServices,
    toggleService,
    actionTitle,
    onComplete,
    onCancel,
}) => {
    const { services, error } = useRepairOptions(session, productId);

    useEffect(() => {
        if (error) {
            alert(error.message);
        }
    }, [error]);

    return (
        <div className={styles.purposeSelection}>
            <PageTitle title="修理内容を選択してください" />
            {services.length > 0 ? (
                <>
                    <div className={styles.repairOptionsPicker}>
                        <div className={styles.header}>即日修理</div>
                        <div className={styles.optionsList}>
                            {services.map((service) => (
                                <label key={service.id} className={styles.item}>
                                    <input
                                        type="checkbox"
                                        checked={selectedServices.some((s) => s.id === service.id)}
                                        onChange={() => toggleService(service)}
                                    />
                                    {service.name}
                                </label>
                            ))}
                        </div>
                    </div>
                    <AttentionNotice note="※ 店頭にて、修理希望箇所以外にも修理が必要と判断された場合は、修理をお受けできないことがあります。" />
                </>
            ) : (
                <p>選択した機種の修理には対応していません</p>
            )}
            <PageActions
                actionTitle={actionTitle ?? '店舗を選択する'}
                actionButtonDisabled={selectedServices.length === 0}
                onOk={onComplete}
                onCancel={onCancel}
            />
        </div>
    );
};

export default PurposeSelection;
